// AROMA COMPASS — Le 5 domande del percorso.
// Ogni risposta assegna punti a una o più categorie emozionali (vedi oils.js).
// La logica di scoring è definita in /lib/scoring.js.
// I testi `label` / `prompt` / `eyebrow` sono in italiano, le varianti `*_en` in inglese.

export const QUESTIONS = [
  {
    id: "q1",
    eyebrow: "01 · Il momento presente",
    eyebrow_en: "01 · The present moment",
    prompt: "Come ti senti in questo momento?",
    prompt_en: "How are you feeling right now?",
    options: [
      { label: "Un po' stanca, con poca energia", label_en: "A little tired, with low energy", scores: { energia: 3, risveglio: 2, attivazione: 1 } },
      { label: "Confusa, senza una direzione chiara", label_en: "Confused, without a clear direction", scores: { direzione: 3, chiarezza: 2, sblocco: 1 } },
      { label: "In tensione, mi serve calma", label_en: "Tense, I need calm", scores: { calma: 3, forte_calma: 2, serenita: 1 } },
      { label: "Bloccata, come se qualcosa non scorresse", label_en: "Stuck, as if something isn't flowing", scores: { sblocco: 3, direzione: 1, nuovo_inizio: 2 } },
      { label: "Sensibile, in cerca di dolcezza", label_en: "Sensitive, longing for softness", scores: { abbraccio: 3, aiuto: 2, serenita: 1 } },
      { label: "Curiosa, in attesa di qualcosa di nuovo", label_en: "Curious, waiting for something new", scores: { nuovo_inizio: 3, risveglio: 2, significato: 1 } },
    ],
  },
  {
    id: "q2",
    eyebrow: "02 · Il tuo bisogno",
    eyebrow_en: "02 · Your need",
    prompt: "Di cosa senti di avere maggiormente bisogno?",
    prompt_en: "What do you feel you need most?",
    options: [
      { label: "Di ritrovare slancio e vitalità", label_en: "To regain momentum and vitality", scores: { energia: 3, risveglio: 2, attivazione: 2 } },
      { label: "Di silenzio, quiete, respiro", label_en: "Silence, quiet, breath", scores: { calma: 3, forte_calma: 2, serenita: 2 } },
      { label: "Di sentirmi accolta e sostenuta", label_en: "To feel welcomed and supported", scores: { abbraccio: 3, aiuto: 3 } },
      { label: "Di chiarezza mentale, di ordine", label_en: "Mental clarity, order", scores: { chiarezza: 3, direzione: 2, governare: 1 } },
      { label: "Di riequilibrare qualcosa dentro", label_en: "To rebalance something inside", scores: { equilibrio: 3, serenita: 1, significato: 1 } },
      { label: "Di gratitudine, di sentirmi leggera", label_en: "Gratitude, to feel lighter", scores: { gratitudine: 3, soddisfazione: 2, gioia: 2, abbondanza: 1, serenita: 1 } },
      { label: "Di trattenere e consolidare ciò che sto imparando", label_en: "To retain and consolidate what I'm learning", scores: { memoria: 3, consolidamento: 2, chiarezza: 1 } },
    ],
  },
  {
    id: "q3",
    eyebrow: "03 · Ciò che senti fermo",
    eyebrow_en: "03 · What feels still",
    prompt: "Cosa senti come bloccato o faticoso adesso?",
    prompt_en: "What feels blocked or heavy right now?",
    options: [
      { label: "Fatico ad iniziare, a mettermi in moto", label_en: "I struggle to start, to get moving", scores: { attivazione: 3, energia: 2, sblocco: 1 } },
      { label: "Mi sento ferma, come in stallo", label_en: "I feel still, as if at a standstill", scores: { sblocco: 3, nuovo_inizio: 2, direzione: 1 } },
      { label: "Ho troppi pensieri, non riesco a scegliere", label_en: "Too many thoughts, I can't choose", scores: { chiarezza: 3, direzione: 2, governare: 2 } },
      { label: "Sento un peso emotivo che non passa", label_en: "I feel an emotional weight that won't pass", scores: { aiuto: 3, forte_calma: 2, equilibrio: 1 } },
      { label: "Faccio fatica a lasciar andare", label_en: "I find it hard to let go", scores: { trasferire: 3, nuovo_inizio: 2, equilibrio: 1 } },
      { label: "Non riesco a dare senso a quello che vivo", label_en: "I can't make sense of what I'm living", scores: { significato: 3, chiarezza: 1, equilibrio: 1 } },
    ],
  },
  {
    id: "q4",
    eyebrow: "04 · La direzione interiore",
    eyebrow_en: "04 · The inner direction",
    prompt: "Verso quale stato interiore vorresti muoverti?",
    prompt_en: "Toward what inner state would you like to move?",
    options: [
      { label: "Verso una nuova energia, un nuovo inizio", label_en: "Toward new energy, a new beginning", scores: { energia: 3, nuovo_inizio: 2, risveglio: 2 } },
      { label: "Verso una direzione più chiara e decisa", label_en: "Toward a clearer, more decisive direction", scores: { direzione: 3, attivazione: 2, governare: 2 } },
      { label: "Verso una calma profonda e stabile", label_en: "Toward a deep, stable calm", scores: { forte_calma: 3, calma: 2, serenita: 2 } },
      { label: "Verso un abbraccio, un senso di casa", label_en: "Toward an embrace, a sense of home", scores: { abbraccio: 3, aiuto: 2, serenita: 1 } },
      { label: "Verso maggiore equilibrio e armonia", label_en: "Toward greater balance and harmony", scores: { equilibrio: 3, serenita: 2, significato: 1 } },
      { label: "Verso una piena consapevolezza di me", label_en: "Toward a full awareness of myself", scores: { condurre: 3, significato: 2, governare: 2 } },
      { label: "Verso una mente più lucida e capace di ricordare", label_en: "Toward a clearer mind, able to remember", scores: { memoria: 3, consolidamento: 2, chiarezza: 1 } },
    ],
  },
  {
    id: "q5",
    eyebrow: "05 · Il desiderio da ritrovare",
    eyebrow_en: "05 · The feeling you long to recover",
    prompt: "Quale sensazione descrive meglio ciò che desideri ritrovare?",
    prompt_en: "Which feeling best describes what you long to recover?",
    options: [
      { label: "«Sono di nuovo in movimento»", label_en: "\"I'm moving again.\"", scores: { attivazione: 3, energia: 2, direzione: 1 } },
      { label: "«So dove voglio andare»", label_en: "\"I know where I want to go.\"", scores: { direzione: 3, governare: 2, chiarezza: 1 } },
      { label: "«Respiro, e va bene così»", label_en: "\"I breathe, and that's enough.\"", scores: { calma: 3, forte_calma: 2, serenita: 2 } },
      { label: "«Mi sento accolta, non sono sola»", label_en: "\"I feel welcomed; I am not alone.\"", scores: { abbraccio: 3, aiuto: 2, serenita: 1 } },
      { label: "«Ricomincio da capo, con fiducia»", label_en: "\"I start again, with trust.\"", scores: { nuovo_inizio: 3, risveglio: 2, energia: 1 } },
      { label: "«Ringrazio ciò che ho, ora»", label_en: "\"I'm grateful for what I have, now.\"", scores: { gratitudine: 3, soddisfazione: 2, abbondanza: 2, gioia: 1, serenita: 1 } },
    ],
  },
];
